import React, { Component } from "react";
import { AgGridReact as AgGridReactQTS } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Header from "../../header/header";
import { getEstDate } from "../../utility/utility";

class d2bRejectQueueTxnScreen extends Component {
  state = {
    mtcn: "",
    pay_agent: "",
    queue_num: "",
    delivery_code: "",
    curTime:getEstDate(),
    columns: [
      { field: "mtcn10", headerName: "MTCN", flex: 1 },
      { field: "mtcn", headerName: "MTCN-16", flex: 1 },
      { field: "payAgent", headerName: "PAY AGENT", flex: 1 },
      { field: "queueNum", headerName: "QUEUE NUM", flex: 1 },
      { field: "deliveryCode", headerName: "DELIVERY CODE", flex: 1 },
    ],
    rows: [],
    gridApi: null,
    paginationValQueue: "25",
    defaultColumnDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    paginationOptionQueueTransScreen: [25, 50, 100, 500],
    overlayLoadingTemplateD2BRQTS: '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplateD2BRQTS: '<span style="">No Records Found</span>',
  };
  onChangeControlD2BRejectQueueMonitor = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onGridReadyD2BRejectQueueTransScreen = (params) => {
    this.setState({
      accessGrantD2BRT:this.props.location.state.data.accessGrantD2BRT,
      accessGrantWriteD2BRT:this.props.location.state.data.accessGrantWriteD2BRT,
      operatorIdD2BRT:this.props.location.state.data.operatorIdD2BRT,
    })
    if (params) {
      this.setState({ gridApi: params.api });
    }
    this.setState({
      rows: this.props.location.state.records,
    });
  };
  onPageSizeChangedD2BRejectQueueTransScreen = (e) => {
    this.setState({ paginationValQueueTrans: e.target.value });
    this.state.gridApi.paginationSetPageSize(Number(e.target.value));
  };
  onHandleBackD2BRejectQueueTransScreen = () => {
    this.props.history.push({
      pathname: "/d2b-reject-queue-monitor-search",
      state: { data: this.props.location.state.data },
    });
  };

  onHandleExportRQTS = () => {
    var params = {
      fileName: 'd2b_reject_queue_transaction.csv',
    };
    this.state.gridApi.exportDataAsCsv(params);
  }

  render() {
    return (
      <>
        <Header history={this.props.history} heading="D2B REJECT QUEUE MONITOR" />
        <div
          className="container-fluid"
          data-test="component-queue-trans-screen"
        >
          <div className="card-body">
            <h4 className="card-title main-heading ">
              Queue Transactions Screen
            </h4>
            <div className="card">
              <div className="card-header bg-dark text-white card-header-custom">
                Queue Transactions
              </div>
              <div className="card-body card-body-custom">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="pagination-dropdown">
                      <label htmlFor="pagination-select-label">
                        No of records per page:
                      </label>
                      <select
                        className="form-control form-control-sm"
                        onChange={(e) => {
                          this.onChangeControlD2BRejectQueueMonitor(e);
                          this.onPageSizeChangedD2BRejectQueueTransScreen(e);
                        }}
                        value={this.state.paginationValQueueTrans}
                        name="paginationDropdownQueueTrans"
                      >
                        {this.state.paginationOptionQueueTransScreen.map(
                          (val) => {
                            return (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 text-center">
                    TOTAL RECORDS: {this.state.rows.length}
                  </div>
                  <div className="col-lg-3">DATE/TIME:{this.state.curTime}</div>
                </div>
               </div>           
                <div
                  className="card-body ag-theme-balham"
                  style={{ height: 600, width: "100%" }}
                >
                  <AgGridReactQTS
                    rowData={this.state.rows}
                    columnDefs={this.state.columns}
                    defaultColDef={this.state.defaultColumnDef}
                    pagination={true}
                    paginationPageSize={25}
                    onGridReady={this.onGridReadyD2BRejectQueueTransScreen}
                    data-test="component-grid"
                    enableCellTextSelection={true}
                    overlayLoadingTemplate={
                      this.state.overlayLoadingTemplateD2BRQTS
                    }
                    overlayNoRowsTemplate={
                      this.state.overlayNoRowsTemplateD2BRQTS
                    }
                    ensureDomOrder={true}
                  ></AgGridReactQTS>
                </div>
              </div>
              <div className="form-group row ">
                <div className="col-lg d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-warning mr-4 mar-top10"
                    onClick={this.onHandleBackD2BRejectQueueTransScreen}
                  >
                    GO TO D2B REJECT QUEUE MONITOR
                  </button>
                  <button
                    type="button"
                    className="btn btn-warning mar-top10"
                    onClick={this.onHandleExportRQTS}
                  >
                   Export
                  </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default d2bRejectQueueTxnScreen;
